import React, {ReactNode} from 'react'
import classNames from 'classnames'

import {useScreenType} from '@/hooks'

import styles from './ValidationHint.scss'

interface ValidationHintProps {
    children: ReactNode
}

export const ValidationHint: React.FC<ValidationHintProps> = ({children}) => {
    const {isMobile} = useScreenType()

    return (
        <div
            className={classNames(styles.validationHint, {[styles.validationHintMobile]: isMobile})}
        >
            {children}
        </div>
    )
}
